// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

// Lazy-loaded Component
const CouponConfirmationPage = lazy(
  () => import('pages/accounting/couponConfirmationPage')
);
const CouponConfirmation = (
  <Route
    path={`${routeName.couponConfirmation}/:id`}
    element={
      <PrivateRoute name={resourceName.couponConfirmation}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <CouponConfirmationPage />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default CouponConfirmation;
